<template>
  <div>
    <the-nav-bar :title="$t('invite.ruleTitle')" />
    <div class="body-wrapper">
      <div
        v-for="i in 5"
        :key="i"
        :class="['list-item', 'row-align-center']"
      >
        <!-- <div class="img-box">
          <img :src="require(`./rule-img-${i}.png`)" alt="" class="img" />
        </div> -->
        <div class="text-box row">
          <div class="index">{{ `${i}` }}. </div>
          <div>
            <h3 class="title" v-html="$t(`invite.rules[${i - 1}].title`)"></h3>
            <p class="text" v-html="$t(`invite.rules[${i - 1}].content`)"></p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { Field, FieldItem } from 'mand-mobile';
export default {
  components: {
    TheNavBar,
    [FieldItem.name]: FieldItem,
    [Field.name]: Field,
  },
  computed: {

  },
  methods: {

  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding-bottom: 40vw;

  >>> .strong {
    color: color-primary;
  }
}

.list-item {
  margin: 5.33vw 5.33vw;

  &.reverse {
    flex-direction: row-reverse;

    .text-box {
      padding-right: 2.13vw;
      padding-left: 0;
    }
  }

  .img {
    width: 28.27vw;
  }

  .text-box {
    padding-left: 2.13vw;
    padding-right: 0;
  }

  .index {
    margin-right: 2.13vw;
    font-size: 4.27vw;
    line-height: 5.33vw;
    font-weight: bold;
  }

  .title {
    margin: 0;
    font-size: 4.27vw;
    line-height: 5.33vw;
  }

  .text {
    font-size: 3.2vw;
    line-height: 4.27vw;
    color: color-text-caption;

    >>> a {
      text-decoration: none;
      color: color-primary;
    }
  }
}

.division {
  height: 5.33vw;
  background: #F8FBFC;
}

.field {
  margin: 0;
  padding: 0;

  .icon {
    width: 4.8vw;
    height: 4.8vw;
    color: color-text-base;
  }

  >>> {
    .md-field-item-content {
      padding: 0 5.07vw;
      min-height: 17.07vw;

      &:before {
        display: none;
      }
    }
  }
}
</style>
